<div class="configuration-compound-select-wrapper">
  <mat-form-field>
    <mat-select
      #firstSelectValue
      [matTooltip]="helpTooltip"
      (selectionChange)="selectedFieldChanged($event)"
    >
      <mat-option>Not selected</mat-option>
      <mat-option *ngFor="let field of placeMarksFields.PrimaryFields; let i = index;"
                  [value]="placeMarksFields.TableKeys[i]">
        {{ field }}
      </mat-option>
    </mat-select>
    <mat-placeholder>{{ placeholder }}</mat-placeholder>
  </mat-form-field>

  <mat-form-field
    [matTooltip]="helpTooltip">
    <mat-select
      #secondSelectValue
      placeholder="UoM" (selectionChange)="selectedUnitOfMeasurementChanged($event)">
      <mat-option *ngFor="let measurementSystemOption of measurementSystemOptions"
                  [value]="measurementSystemOption.value">
        {{ measurementSystemOption.title }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-checkbox
    #checkboxValue
    disableRipple
    matTooltip="{{ 'configurations-fields.tooltips.InvertValue' | translate}}"
    (change)="selectedInvertValueChanged($event)"
  ></mat-checkbox>
</div>


